export const AUTH_DATA_STATE_KEY = 'token';
export const LAST_CONNECTED_EMAIL = 'lastemail';
export const LAST_CONNECTED_LANGUAGE = 'lastLanguage';

